module.exports = __webpack_public_path__ + "img/header-background.14a1b183.jpg";